
import respUtility from '~/mixins/respUtility';

export default {
  name: 'ListingProductsSort',
  mixins: [respUtility],
  props: {
    searchParams: {
      type: Object,
      default() { return {}; },
    },
    filtersFromRoute: {
      type: Object,
      default() { return {}; },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isBrandPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sortVariants: [
        { text: 'Recommended', value: 'RELEVANCE' },
        { text: 'Price: Low to High', value: 'PRICE_FROM_LOW' },
        { text: 'Price: High to Low', value: 'PRICE_FROM_HIGHT' },
        { text: 'Newest First', value: 'NEW' },
        { text: 'Top Rated', value: 'TOP_RATED' },
      ],
      modal: false,
      nodeId: 'sortActivator',
    };
  },
  computed: {
    selectSort() {
      const value = this.searchParams.sortBy || this.$store.getters['listing/defaultParams']?.sortBy;
      const variant = this.sortVariants.find((v) => v.value === value);
      return variant || this.sortVariants[0];
    },
    filtersCount() {
      let count = 0;
      if (!this.filtersFromRoute) {
        return count;
      }
      if (this.filtersFromRoute.customPrice) {
        count += 1;
      }
      if (!this.filtersFromRoute.selected) {
        return count;
      }
      Object.values(this.filtersFromRoute.selected).forEach((arr) => {
        if (Array.isArray(arr) && arr.length) {
          count += arr.length;
        }
      });
      return count;
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
    colorIcon() {
      return this.isBoutiquePage ? this.$cp.tertiary_specialMain : this.$cp.gray12;
    },
  },
  methods: {
    changeSort(select) {
      if (select.value === this.selectSort.value) {
        return;
      }
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          'sort-by': select.value.toLowerCase(),
          page: 1,
        },
      });
    },
  },
};
